//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
  name: 'index',
  data () {
    return {
      promoWays: [{
        iconName: 'yingyongshangdiantuiguang',
        promoWaysTitle: '应用商店推广',
        promoWaysDescription: '上架各大应用商店，进行关键词覆盖、换量合作、广告投放等推广; '
      }, {
        iconName: 'xinxiliuguanggao1',
        promoWaysTitle: '信息流广告',
        promoWaysDescription: '筛选目标用户精准直达，通过各平台信息流广告实现优质曝光;'
      }, {
        iconName: 'shijianyingxiao1',
        promoWaysTitle: '事件营销',
        promoWaysDescription: '针对APP特点，制定个性化事件营销方案推广，吸引用户兴趣与关注;'
      }, {
        iconName: 'hongrentuiguang',
        promoWaysTitle: '红人推广',
        promoWaysDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导;'
      }, {
        iconName: 'gongguanruanwen',
        promoWaysTitle: '公关软文',
        promoWaysDescription: '科技报道，新闻稿件，软性植入，优化搜索情况，树立APP在网络上的正面形象; '
      }, {
        iconName: 'shipintoufang',
        promoWaysTitle: '视频投放',
        promoWaysDescription: '制作创意宣传视频，通过数据筛选精准用户，投放于各类视频网站;'
      }
      ],
      promoAdvantages: [{
        iconName: 'jingzhunyonghuhuoqu1',
        promoAdvanTitle: '精准用户获取  ',
        promoAdvanDescription: '基于智能大数据分析，精确获取目标用户网络偏好;'
      }, {
        iconName: 'hailiangyouzhiziyuan',
        promoAdvanTitle: '海量优质资源',
        promoAdvanDescription: '覆盖90%以上有传播价值的媒体资源;'
      }, {
        iconName: 'yingyongshangdianyouhua',
        promoAdvanTitle: '应用商店优化 ',
        promoAdvanDescription: '提供数据分析、数据监测、关键词优化、榜单效果、竞品分析等全景化 ASO 营销服务;'
      }, {
        iconName: 'zhuanyeyingxiaojingyan',
        promoAdvanTitle: '专业营销经验 ',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'gaoxiaozhuanshufuwu',
        promoAdvanTitle: '高效专属服务',
        promoAdvanDescription: '专业运营团队跟进，实时优化推广方案，以达到最佳传播效果;'
      }
      ]
    }
  },
  methods: {},
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/solution/appPromotion/index.vue